<input
  #input
  class="file-drop-zone__input"
  type="file"
  tabindex="-1"
  aria-hidden="true"
  [attr.accept]="accept() || null"
  [multiple]="multiple()"
  (click)="$event.stopPropagation()"
  (change)="onPicked(input)" />
@let zoneIcon = icon();
@if (zoneIcon) {
  <fa-duotone-icon class="file-drop-zone__icon" [icon]="zoneIcon"></fa-duotone-icon>
}
@if (heading() || hint()) {
  <span class="file-drop-zone__text">
    @if (heading()) {
      <strong>{{ heading() }}</strong>
    }
    @if (hint()) {
      <span>{{ hint() }}</span>
    }
  </span>
}
<ng-content />
